'use client';
import { TouchEvent, useRef, useState } from 'react';
import styles from './styles.module.scss';
import ImageCar, { EImageCarLoading } from '../image-car';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import myImageLoader from '@/image.local.loader';

/**
 * @deprecated
 * @description deprecated use CarouselV2
 * @param imgs
 * @param containerWidth
 * @param containerHeight
 * @param imageMargin
 * @param showDots
 * @param showArrows
 * @param dragable
 * @param slideShow
 * @param UseNextImage
 * @param lang
 * @param width
 * @param height
 * @param quality
 * @param limitPlaceHolderHeight
 * @param overflow
 * @param objectFitValue
 * @param disablePlaceHolder
 * @param onNextClick
 * @param onPrevClick
 * @constructor
 */
const Carousel = ({
    imgs,
    containerWidth,
    containerHeight = '',
    imageMargin,
    showDots,
    showArrows = false,
    dragable,
    slideShow,
    UseNextImage = false,
    lang,
    width,
    height,
    quality,
    limitPlaceHolderHeight = false,
    overflow = '',
    objectFitValue = 'contain',
    disablePlaceHolder = false,
    onNextClick,
    onPrevClick,
}: {
    imgs: any[];
    containerWidth: string;
    containerHeight?: string;
    imageMargin: string;
    showDots: boolean;
    showArrows?: boolean;
    dragable: boolean;
    slideShow: boolean;
    UseNextImage?: boolean;
    lang: 'ar' | 'en';
    width?: number;
    height?: number;
    quality?: number;
    limitPlaceHolderHeight?: boolean;
    overflow?: string;
    objectFitValue?: 'contain' | 'cover';
    disablePlaceHolder?: boolean;
    onNextClick?: (imageIndex: number) => void;
    onPrevClick?: (imageIndex: number) => void;
}) => {
    const indexDots = {
        borderRadius: '26px',
        width: '8px',
        height: '8px',
        backgroundColor: 'white',
        marginRight: '6px',
        transition: '0.3s ease-in-out',
        opacity: 0.5,
    };
    const indexDotsActive = {
        borderRadius: '26px',
        width: '16px',
        height: '8px',
        backgroundColor: 'white',
        marginRight: '6px',
        transition: '0.3s ease-in-out',
        opacity: 1,
    };

    const imgRef = useRef<HTMLDivElement>(null);
    const sliderContainer = useRef<HTMLDivElement>(null);
    const [imgsState, setImgsState] = useState<boolean[]>(
        new Array(imgs.length)
    );
    const [startX, setStartX] = useState(0);
    const [currentImage, setCurrentImage] = useState(0);
    const [pressed, setPressed] = useState(false);

    const xDown = useRef<number | null>(null);
    const yDown = useRef<number | null>(null);
    //TouchEvent |ObjectEvent

    function handleTouchStart(e: TouchEvent) {
        const firstTouch = e.touches[0];
        xDown.current = firstTouch.clientX;
        yDown.current = firstTouch.clientY;
    }

    function handleTouchMove(evt: any, index: number) {
        if (!xDown.current || !yDown.current) {
            return;
        }

        const xUp = evt.touches[0].clientX;
        const yUp = evt.touches[0].clientY;

        const xDiff = xDown.current - xUp;
        const yDiff = yDown.current - yUp;

        if (Math.abs(xDiff) > Math.abs(yDiff)) {
            /*most significant*/
            if (xDiff > 0) {
                swip(index, 'left');
            } else {
                swip(index, 'right');
            }
        }
        /* reset values */
        xDown.current = null;
        yDown.current = null;
    }

    const slide = (index: number) => {
        const newImgState = [false];
        if (imgRef.current) {
            imgRef.current.style.transition = '0.4s ease-in-out';
            imgRef.current.style.transform = `translate(calc(-100% * ${index}),0)`;
            for (let i = 0; i < imgsState.length; i += 1) {
                newImgState[i] = i === index ? true : false;
            }
        }
        setCurrentImage(index);
        setImgsState(newImgState);
    };
    const swip = (index: number, direction: string) => {
        const newIndex = direction === 'left' ? index + 1 : index - 1;
        let validIndex = newIndex >= imgsState.length ? 0 : newIndex;
        validIndex = validIndex < 0 ? imgsState.length - 1 : validIndex;
        const newImgState = [false];

        if (imgRef.current) {
            imgRef.current.style.transition = '0.4s ease-in-out';
            imgRef.current.style.transform = `translate(calc(-100% * ${validIndex}),0)`;

            for (let i = 0; i < imgsState.length; i += 1) {
                newImgState[i] = i === validIndex ? true : false;
            }
        }
        setCurrentImage(validIndex);
        setImgsState(newImgState);
    };
    const changeImageOnHover = () => {
        setTimeout(() => {
            if (currentImage + 1 >= imgsState.length) {
                slide(0);
            } else {
                slide(currentImage + 1);
            }
        }, 1000);
    };
    const checkBoundary = () => {
        if (sliderContainer.current && imgRef.current) {
            const outer = sliderContainer.current.getBoundingClientRect();
            const number = parseInt(imageMargin.split('p')[0]);
            const inner = imgRef.current.getBoundingClientRect();
            const numberOfDisplayedImages =
                Math.round((outer.width / inner.width) * 10) / 10;
            const image_length = inner.width + number;
            const total_length = image_length * imgs.length;
            // const rightBound = Math.ceil(numberOfDisplayedImages * inner.width + number * imgs?.length);
            const rightBound =
                total_length / numberOfDisplayedImages + image_length;

            // const rightBound = Math.ceil(
            //   ((inner.width + number) * imgs?.length) / numberOfDisplayedImages,
            // );
            if (parseInt(imgRef.current.style.left) > 0) {
                lang === 'en'
                    ? (imgRef.current.style.left = '0px')
                    : (imgRef.current.style.left = '0px');
            }
            if (
                Math.abs(parseInt(imgRef.current.style.left)) >= rightBound &&
                Math.sign(inner.left) === -1
            ) {
                // console.log('max right bound', outer);
                lang === 'en'
                    ? (imgRef.current.style.left = `-${rightBound}px`)
                    : (imgRef.current.style.left = `-${rightBound}px`);
            }
        }
    };
    const mouseDown = (e: any) => {
        setPressed(true);
        if (imgRef.current) {
            setStartX(e.clientX - imgRef?.current.offsetLeft);
        }
        // sliderContainer.current.style.cursor = 'grabbing';
    };
    const mouseMove = (e: any) => {
        if (!pressed) return;
        e.preventDefault();
        const x = e.clientX;
        if (imgRef.current) {
            imgRef.current.style.left = `${x - startX}px`;
        }
        checkBoundary();
    };
    const mouseUp = () => {
        setPressed(false);
    };

    return (
        <div
            ref={sliderContainer}
            className={styles.carousel_slider_container}
            style={{ height: containerHeight, overflow: overflow }}
        >
            <div
                ref={imgRef}
                className={styles.imgContainer}
                style={{
                    width: containerWidth,
                    left: 0,
                    position: dragable ? 'absolute' : 'inherit',
                    height: containerHeight,
                }}
            >
                {imgs?.map((img, index) => (
                    <div
                        key={`img-${index}`}
                        onMouseDown={dragable ? e => mouseDown(e) : undefined}
                        onMouseMove={dragable ? e => mouseMove(e) : undefined}
                        onMouseUp={dragable ? () => mouseUp() : undefined}
                        onMouseLeave={() => setPressed(false)}
                        onMouseEnter={
                            slideShow ? () => changeImageOnHover() : undefined
                        }
                        onTouchStart={e => handleTouchStart(e)}
                        onTouchMove={e => handleTouchMove(e, index)}
                        style={{
                            width: '100%',
                            display: 'flex',
                            height: '100%',
                            marginRight: imageMargin,
                            backgroundColor: '#F9FAFB',
                        }}
                        onDragStart={e => e.preventDefault()}
                    >
                        {UseNextImage ? (
                            //@TODO ::  Check died zone
                            <ImageCar
                                // ref={addToRefs}
                                width={width}
                                height={height}
                                quality={quality}
                                style={{ width: '100%', height: '100%' }}
                                src={img.image || img}
                                alt=""
                                loadingMethod={EImageCarLoading.lazy}
                                limitPlaceHolderHeight={limitPlaceHolderHeight}
                                objectFitValue={objectFitValue}
                                disablePlaceHolder={disablePlaceHolder}
                            />
                        ) : (
                            <img
                                alt={' '}
                                width={width}
                                height={height}
                                src={myImageLoader({
                                    src: img.image || img,
                                    width: width,
                                    height: height,
                                    quality: quality,
                                })}
                            />
                        )}
                    </div>
                ))}
            </div>
            {showDots && (
                <div className={styles.indexDotsContainer}>
                    {imgs.map((item, index) => (
                        <div
                            onClick={() => slide(index)}
                            key={`indexDotsContainer${index}`}
                            style={
                                imgsState[index] || currentImage === index
                                    ? indexDotsActive
                                    : indexDots
                            }
                        ></div>
                    ))}
                </div>
            )}
            {showArrows && imgs.length > 1 ? (
                <div className={styles.indexArrowsContainer}>
                    <button
                        onClick={() => {
                            slide(Math.max(0, currentImage - 1));
                            onPrevClick(currentImage);
                        }}
                        style={{ opacity: currentImage === 0 ? '30%' : '100%' }}
                        disabled={currentImage === 0}
                    >
                        <ChevronLeft sx={{ width: '20px', height: '20px' }} />
                    </button>
                    <button
                        onClick={() => {
                            slide(Math.min(imgs.length - 1, currentImage + 1));
                            onNextClick(currentImage);
                        }}
                        style={{
                            opacity:
                                currentImage === imgs.length - 1
                                    ? '30%'
                                    : '100%',
                        }}
                        disabled={currentImage === imgs.length - 1}
                    >
                        <ChevronRight sx={{ width: '20px', height: '20px' }} />
                    </button>
                </div>
            ) : null}
        </div>
    );
};

export default Carousel;
